import { RadioButton } from '~/shared/ui'
import { useFilters } from '../../../model'

export function StatusFilter() {
  const { filters, setFilters } = useFilters()

  return (
    <>
      <div className="flex items-center px-2 py-0.5">
        <RadioButton
          label="Awaiting / In Progress"
          gutter
          size="small"
          checked={filters.status.includes('awaiting')}
          onChange={() => {
            setFilters({
              status: ['awaiting'],
            })
          }}
        />
      </div>
      <div className="flex items-center px-2 py-0.5">
        <RadioButton
          label="Finished"
          gutter
          size="small"
          checked={filters.status.includes('finished')}
          onChange={() => {
            setFilters({
              status: ['finished'],
            })
          }}
        />
      </div>
      <div className="mb-1 flex items-center px-2 py-0.5">
        <RadioButton
          label="Auto Approved"
          gutter
          size="small"
          checked={filters.status.includes('auto_reviewed')}
          onChange={() => {
            setFilters({
              status: ['auto_reviewed'],
            })
          }}
        />
      </div>
    </>
  )
}
